import contact_img from '~/assets/images/contact_img.png';
import form_regis from '~/assets/images/formRegis.png';
import profile from '~/assets/images/profile.png';
import { Box, Typography, Divider } from "@mui/material";
import { Link } from 'react-router-dom';
const ExamInstruction = () => {
    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 250,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center',
                    textAlign: "center"
                }}>
                HƯỚNG DẪN ĐĂNG KÝ DỰ THI
            </Box>
            {/* <ListArticle category='Hướng dẫn đăng ký thi' /> */}
            <Box sx={{ maxWidth: 'md', marginInline: 'auto', marginBlock: 6, p: { xs: 2 }, textAlign: 'justify' }}>
                <Typography
                    variant='h6'
                    sx={{ color: "var(--primary)", fontWeight: 'bold', textAlign: 'center' }}>
                    HƯỚNG DẪN ĐĂNG KÝ THI CHỨNG CHỈ ỨNG DỤNG CÔNG NGHỆ THÔNG TIN
                </Typography>
                <Divider sx={{ mt: 4 }} />
                <Typography sx={{ marginBlock: 4 }}>
                    Bạn có thể đăng ký thi theo 2 hình thức: (1) Đăng ký Online hoặc (2) Đăng ký trực tiếp Trung Tâm.
                    Trong đó, bạn được khuyến nghị sử dụng chức năng đăng ký Online để không mất nhiều thời gian chờ
                    đợi tại Trung Tâm.
                </Typography>
                <Typography sx={{ color: "var(--primary)", marginBlock: 4, fontWeight: 'bold' }}>
                    1. ĐĂNG KÝ ONLINE
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    Quá trình đăng ký online sẽ trải qua các Bước sau:
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    <span style={{ color: "var(--primary)", fontWeight: "bold" }}>Bước 1. Đăng ký: </span> Vào trang <Link target='_blank' to={"https://udcntt.dthu.edu.vn/"} className='link-blue' style={{
                        textDecoration: 'none',
                        color: "var(--primary)",
                        fontWeight: "bold",
                    }}>
                        https://udcntt.dthu.edu.vn/
                    </Link> điền thông tin vào màn hình nhập liệu "Đăng ký thi".
                    Nhập đầy đủ các thông tin theo yêu cầu, chọn vào nút lệnh "Đăng ký", khi toàn bộ thông tin hợp lệ bạn sẽ nhận được thông báo
                    đăng ký thành công.
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    Lưu ý rằng nếu bạn là sinh viên tại Trường Đại học Đồng Tháp, bạn nên cho biết thông tin về
                    Khoa và Lớp học để thuận lợi cho việc thống kê sau này.
                    <br/>Ảnh thẻ nên chụp rõ nét, không bị mờ và không lóa sáng, chỉ cắt phần ảnh thẻ không để dư vật thể khác như bàn, tường, ghế, tay, v.v.
                </Typography>
                <Box sx={{
                    width: '100%',
                    minHeight: { md: 800, xs: 350 },
                    backgroundImage: `url(${form_regis})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }} />
                <Typography sx={{ marginBlock: 4 }}>
                    <span style={{ color: "var(--primary)", fontWeight: "bold" }}> Bước 2. In phiếu đăng ký: </span>
                    Vào mục Tra cứu {'>'} Thông tin thí sinh {'>'} Nhập mã số sinh viên hoặc số CCCD chọn Tìm kiếm.
                    Kiểm tra lại thông tin đăng ký, nếu có sai sót vui lòng liên hệ Trung tâm để cập nhật lại thông tin, ngoài ra bạn cũng có thể theo dõi trạng thái đăng ký tại đây. Nếu trạng thái là "Đã đăng ký" thì bạn đã đăng ký thành công, nếu là "Đã duyệt" thì bạn đã đủ điều kiện dự thi.
                    Nếu thông tin hoàn toàn chính xác, chọn In phiếu đăng ký và dán ảnh vào vị trí được qui định trên phiếu, hoặc bạn có thể mang ảnh đến
                    Trung tâm để được hỗ trợ in và dán ảnh.
                </Typography>
                <Box sx={{
                    width: '100%',
                    minHeight: { md: 1200, xs: 500 },
                    backgroundImage: `url(${profile})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }} />
                <Typography sx={{ color: "var(--primary)", marginBlock: 4, fontWeight: "bold" }}>
                    2. ĐĂNG KÝ TRỰC TIẾP
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    Bạn có thể mang ảnh đến đăng ký trực tiếp tại Trung tâm Ngoại ngữ và Tin học, Trường Đại học Đồng Tháp.
                    Tuy nhiên, sẽ mất nhiều thời gian để nhập liệu và in ấn khi số lượng thí sinh nhiều.
                    Chúng tôi khuyến nghị bạn nên đăng ký online rồi hãy đến Trung Tâm, việc làm này sẽ giúp giải
                    quyết yêu cầu đăng ký được nhanh chóng.
                </Typography>
                <Typography sx={{ color: "var(--primary)", marginBlock: 4, fontWeight: "bold" }}>
                    3. CÁCH THỨC NỘP HỒ SƠ DỰ THI VÀ ĐÓNG PHÍ DỰ THI
                </Typography>
                <Box sx={{ marginBlock: 4, ml: 4 }}>
                    <Typography sx={{ marginBlock: 2 }}>
                        Thí sinh hoàn thành thủ tục đăng ký dự thi bằng cách lựa chọn một trong hai cách sau đây:
                    </Typography>
                    <Typography sx={{ color: "var(--primary)", marginBlock: 2, fontWeight: "bold" }}>
                        Cách 1: Nộp hồ sơ trực tiếp
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        Thí sinh đăng ký dự thi trên Website <Link target='_blank' to={"https://udcntt.dthu.edu.vn/"} className='link-blue' style={{
                            textDecoration: 'none',
                            color: "var(--primary)",
                            fontWeight: "bold",
                        }}>
                            https://udcntt.dthu.edu.vn/
                        </Link> sau đó chuẩn bị hồ sơ dự thi {"("}gồm 1 phiếu đăng ký dự thi có dán 2 tấm ảnh 4x6, 1 tấm ảnh 4x6 và 1 CCCD photo không cần công chứng{")"}, đến trực tiếp Phòng giao dịch Trung tâm Ngoại ngữ và Tin học, Ki-ốt 1,2,
                        Trường Đại học Đồng Tháp, số 783 Phạm Hữu Lầu, Phường 6, TP Cao Lãnh, Đồng Tháp, để được hỗ trợ
                        hoàn thành thủ tục đăng ký thi.
                    </Typography>
                    <Typography sx={{ color: "var(--primary)", marginBlock: 2, fontWeight: "bold" }}>
                        Cách 2: Nộp hồ sơ dự thi qua đường bưu điện và chuyển khoản phí dự thi
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        Thí sinh đăng ký dự thi trên Website <Link target='_blank' to={"https://udcntt.dthu.edu.vn/"} className='link-blue' style={{
                            textDecoration: 'none',
                            color: "var(--primary)",
                            fontWeight: "bold",
                        }}>
                            https://udcntt.dthu.edu.vn/
                        </Link> sau đó in Phiếu đăng kí dự thi, dán ảnh,
                        chuẩn bị hồ sơ dự thi {"("}gồm 1 phiếu đăng ký dự thi có dán 2 tấm ảnh 4x6, 1 tấm ảnh 4x6 và 1 CCCD photo không cần công chứng{")"} và gửi hồ sơ dự thi qua đường bưu điện về địa chỉ:
                        Trung tâm Ngoại ngữ và Tin học, Ki-ốt 1,2, Trường Đại học Đồng Tháp, số 783 Phạm Hữu Lầu, Phường 6,
                        TP Cao Lãnh,Đồng Tháp, Email: ttnnth@dthu.edu.vn, điện thoại: 02773 881 715.
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        Nộp phí dự thi bằng hình thức chuyển khoản theo cú pháp như sau:
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        Tên chủ tài khoản (người nhận): Trường Đại học Đồng Tháp
                    </Typography>
                    <Typography sx={{ marginBlock: 2, display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap" }}>
                        Số tài khoản:
                        <span style={{ color: "var(--primary)", fontWeight: "bold" }}>
                            109000916169 tại Ngân hàng TMCP Đại Chúng Việt Nam - Chi nhánh Đồng Tháp
                        </span>
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        Cú pháp nộp phí dự thi:
                    </Typography>
                    <Typography sx={{ color: "var(--primary)", marginBlock: 2, fontWeight: "bold" }}>
                        [MSSV/CCCD] + [Họ và tên] + [Số điện thoại] + [Thi tin học] + [Tháng thi]
                    </Typography>

                    <Typography sx={{ color: "var(--primary)", marginBlock: 2, fontWeight: "bold" }}>
                        Ví dụ: 001821xxxx Nguyen Van A 093979xxxx Thi tin học T1
                    </Typography>
                    <Typography sx={{ marginBlock: 2 }}>
                        * Lưu ý: thí sinh cần lưu hình ảnh chứng minh đã nộp các khoản phí.
                    </Typography>
                </Box>
                <Typography sx={{ color: "var(--primary)", marginBlock: 2, fontWeight: "bold" }}>
                    *Lưu ý:
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    Thí sinh cần gửi hồ sơ dự thi {"("}gồm 1 phiếu đăng ký dự thi có dán 2 tấm ảnh 4x6, 1 tấm ảnh 4x6 và 1 CCCD photo không cần công chứng{")"} trong vòng 03 ngày kể từ ngày
                    đăng ký dự thi trên Website để hoàn thành thủ tục dự thi theo ngày thi mong muốn.
                    Trung tâm sẽ không giải quyết những trường hợp gửi hồ sơ trễ khi đủ số lượng thí sinh của mỗi kỳ thi.
                </Typography>
                <Typography sx={{ marginBlock: 4 }}>
                    Trước ngày thi 2 ngày, thí sinh vào website <Link target='_blank' to={"https://nnth.dthu.edu.vn/"} className='link-blue' style={{
                        textDecoration: 'none',
                        color: "var(--primary)",
                        fontWeight: "bold",
                    }}>
                        Trung tâm Ngoại ngữ và Tin học
                    </Link> xem danh sách phòng thi và số báo danh của mình.
                </Typography>
            </Box>
        </Box>

    )
}

export default ExamInstruction;